import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export type LabelProps = {
  htmlFor: string
  children: ReactNode
  className?: string
}

export function Label({ htmlFor, children, className }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'block text-xs font-semibold uppercase tracking-[0.14em] text-muted',
        className,
      )}
    >
      {children}
    </label>
  )
}
